
import React, { Fragment, memo } from 'react';
import { Layout, Menu, Breadcrumb,Row, Col, message } from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons';
import './style.scss'
import { useNavigate } from "react-router-dom";
import Colors from '../../assets/themes/colors';
import GlobalSider from '../../components/GlobalSider';
import { appIdentifier, getLocal,} from '../../globalFunctions/api';
import GlobalHeader from '../../components/GlobalHeader';
import { BsBuilding } from "react-icons/bs";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { FaSitemap,FaChalkboardTeacher } from "react-icons/fa";
import { RiAdminLine } from "react-icons/ri";
import { GiArchiveResearch} from "react-icons/gi";

const { Content} = Layout;


const  MngAdminsHome = ()=> {
    
    const localUserType = getLocal(appIdentifier)?.user?.user_type || null 
    
    return(
        <Layout className='mainContainer'>
            
            
            <GlobalHeader title="لوحة ادارة النظام"/>
           
            <Layout>
            
            <GlobalSider currentPage={'mnghome'} currentSub={'sub1'} />
            <Layout
                style={{
                padding: '0 24px 24px',
                }}
            >
                <Breadcrumb
                style={{
                    margin: '16px 0',
                }}
                >
                <Breadcrumb.Item>الرئيسية</Breadcrumb.Item>
                
                </Breadcrumb>
                <Content
                className="site-layout-background"
                style={{
                    padding: 24,
                    margin: 0,
                    minHeight: 280,
                }}
                >
                <Row justify="space-around" style={{padding:50}} >
                
                    <DashItem 
                        visible={localUserType === 'main'}
                        primaryColor={'#16415b'} 
                        secondaryColor={'#16415b'} 
                        icon={<BsBuilding  style={{color:Colors.clear, fontSize:60, textShadow: '0px 1px 2px #000000'}} />} 
                        title = {'ادارة الجامعات'}
                        count={10}
                        pageName={'/unviversities'}
                    />
                    
                    <DashItem 
                        visible={localUserType === 'university' || localUserType === 'main'}
                        primaryColor={'#4db4cc'} 
                        secondaryColor={'#4db4cc'} 
                        icon={<MdOutlineMapsHomeWork  style={{color:Colors.clear, fontSize:70, textShadow: '0px 1px 2px #000000'}} />} 
                        title = {'ادارة الكليات'}
                        count={10}
                        pageName={'/colleges'}
                    />

                    <DashItem 
                        visible={localUserType === 'college' || localUserType === 'main'}
                        primaryColor={'#7fb685'} 
                        secondaryColor={'#7fb685'} 
                        icon={<FaSitemap  style={{color:Colors.clear, fontSize:70, textShadow: '0px 1px 2px #000000'}} />} 
                        title = {'ادارة الاقسام'}
                        count={10}
                        pageName={'/departs'}
                    />

                    <DashItem
                        visible={localUserType === 'depart' || localUserType === 'main'}
                        primaryColor={'#ff906b'} 
                        secondaryColor={'#ff906b    '} 
                        icon={<FaChalkboardTeacher  style={{color:Colors.clear, fontSize:70, textShadow: '0px 1px 2px #000000'}} />} 
                        title = {' ادارة التدريسيين'}
                        count={10}
                        pageName={'/infos'}
                    />

                    <DashItem
                        visible={localUserType === 'depart' || localUserType === 'main'}
                        primaryColor={'#7481c2'} 
                        secondaryColor={'#7481c2    '} 
                        icon={<RiAdminLine  style={{color:Colors.clear, fontSize:70,textShadow: '0px 1px 2px #000000'}} />} 
                        title = {' ادارة المدراء'}
                        count={10}
                        pageName={'/infos'}
                    />

                    <DashItem
                        visible={localUserType === 'teacher' }
                        primaryColor={'#7481c2'} 
                        secondaryColor={'#7481c2    '} 
                        icon={<GiArchiveResearch  style={{color:Colors.clear, fontSize:70,textShadow: '0px 1px 2px #000000'}} />} 
                        title = {' ادارة البحوث المستلمة'}
                        count={''}
                        pageName={'/mng_teacher_thesis'}
                    />
                    
                    {/* <DashItem 
                        primaryColor={'#F4A261'} 
                        secondaryColor={'#EFB68A'} 
                        icon={<UnorderedListOutlined  style={{color:Colors.clear, fontSize:70}} />} 
                        title = {'ادارة الخدمات'}
                        count={10}
                        pageName={'/mngservices'}
                    />

                    <DashItem 
                        primaryColor={'#5D68F2'} 
                        secondaryColor={'#8C93E8'} 
                        icon={<UnorderedListOutlined  style={{color:Colors.clear, fontSize:70}} />} 
                        title = {'مدراء النظام'}
                        count={10}
                        pageName={'/mngamanagers'}
                    />
                    
                    <DashItem
                        primaryColor={'#F25D5D'} 
                        secondaryColor={'#EFA2A2'} 
                        icon={<QuestionCircleOutlined  style={{color:Colors.clear, fontSize:70}} />} 
                        title = {' المستفيدين'}
                        count={10}
                        pageName={'/mngabenefeciaries'}
                    /> */}
                </Row>
                </Content>
            </Layout>
            </Layout>
        </Layout>
    )
}

export default MngAdminsHome




const DashItem = memo( (props)=> {
    const {primaryColor, secondaryColor,icon,title,count,pageName} = props||null
    const {visible} = props||false
    const navigate = useNavigate()

  return (
      <Fragment>
          {
            visible&&
            <Col onClick={()=>navigate(pageName)}  lg={{offset:1, span:7}} md={12} sm={24} xs={24} style={{
                cursor:'pointer',
                borderRadius:8,
                overflow:'hidden',
                height:180,marginBottom:40,
                background: `${primaryColor}`, /* Old browsers */
                background: `-moz-linear-gradient(top,  ${primaryColor} 0%, ${secondaryColor} 100%)` ,/* FF3.6-15 */
                background: `-webkit-linear-gradient(top,  ${primaryColor} 0%,${secondaryColor} 100%)`,/* Chrome10-25,Safari5.1-6 */
                background: `linear-gradient(to bottom,  ${primaryColor} 0%,${secondaryColor} 100%)`, /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            }}>
                <Row style={{height:'100%'}}>
                    <div style={{backgroundColor:primaryColor,width:'40%', height:'100%',alignItems:'center', justifyContent:'center', display:'flex'}} >
                        {icon}
                    </div>
                    <div style={{width:'60%'}}>
                        <h1 style={{textAlign:'center', fontWeight:'bold', fontSize:22, color:Colors.clear, marginTop:32, textShadow: '0px 1px 2px #000000'}}>{title}</h1>
                        {/* <h1 style={{textAlign:'center',fontSize:30, color:Colors.clear, marginTop:32,fontWeight:'bolder'}}>{count}</h1> */}
                    </div>
                </Row>
                
               
            </Col>
          }
      </Fragment>
    
    
  )
}
)
